import layout from "@/views/mainLayout/index.vue";
import { RouteRecordRaw } from "vue-router";

export const constRouter: RouteRecordRaw[] = [
  {
    path: "/",
    component: layout,
    name: "layout",
    children: [
      {
        name: "login",
        path: "/login",
        component: () => import("@/views/login/index.vue"),
      },
      {
        name: "console-edit",
        path: "/edit",
        component: () =>
          import(
            /* webpackChunkName: "editLayout" */ "@/views/mainLayout/editLayout.vue"
          ),
        children: [
          {
            name: "post-edit",
            path: "post-edit",
            component: () =>
              import(
                /* webpackChunkName: "PostMdEditor" */ "@/views/md-editor/PostMdEditor.vue"
              ),
          },
          {
            name: "note-edit",
            path: "note-edit",
            component: () =>
              import(
                /* webpackChunkName: "NoteMdEditor" */ "@/views/md-editor/NoteMdEditor.vue"
              ),
          },
        ],
      },
      {
        name: "postbackup-detail",
        path: "/backup/:postid/:uuid",
        component: () => import("@/views/mainLayout/editLayout.vue"),
        children: [
          {
            name: "default",
            path: "",
            component: () =>
              import("@/views/releaseManagers/postReleaseDetail.vue"),
          },
        ],
      },
      {
        name: "console-home",
        path: "/",
        component: () => import("@/views/mainLayout/menuLayout.vue"),
        redirect: "/post-release",
        children: [
          {
            name: "post-release",
            path: "/post-release",
            component: () =>
              import(
                /* webpackChunkName: "postDraftManager" */ "@/views/draftManagers/postDraftManager.vue"
              ),
          },
          {
            name: "note-release",
            path: "/note-release",
            component: () =>
              import(
                /* webpackChunkName: "noteDraftManager" */ "@/views/draftManagers/noteDraftManager.vue"
              ),
          },
          {
            name: "post-manager",
            path: "/post-manager",
            component: () =>
              import(
                /* webpackChunkName: "postReleaseManager" */ "@/views/releaseManagers/postReleaseManager.vue"
              ),
          },
          {
            name: "note-manager",
            path: "/note-manager",
            component: () =>
              import(
                /* webpackChunkName: "noteReleaseManager" */ "@/views/releaseManagers/noteReleaseManager.vue"
              ),
          },
          {
            name: "dashboard",
            path: "/dashboard",
            component: () =>
              import(
                /* webpackChunkName: "webInfoModifyIndex" */ "@/views/webInfoModify/index.vue"
              ),
          },
        ],
      },
    ],
  },
];
